//export const BASE_URL = 'https://localhost:7161'
//export const BASE_URL = 'http://161.97.111.59:18081'
// export const BASE_URL = 'http://localhost:5000'
export const BASE_URL = 'https://api.evenado.com'